import React from 'react';

import { Box, Typography } from '@mui/material';

import { RadioButtonGroupInput, SelectArrayInput } from 'react-admin';

import { useWatch } from 'react-hook-form';

import { reportTypesDisplayChoices } from '../../../../constants/reportTypes';
import { Actions } from '../../../../constants/actions';

const ReportInput = ({
  action,
}: {
  action: Actions;
}) => {
  const attributes = useWatch({ name: `permissions.${action}.attributes.type` });
  const isEnabled = useWatch({ name: `permissions.${action}.enabled` });
  const isFilteringAttributesDefaultValues = attributes && attributes.length > 0 ? 'yes' : 'no';
  const isFilteringAttributes = useWatch({ name: `permissions.${action}.isFilteringAttributes`, defaultValue: isFilteringAttributesDefaultValues });
  if (!isEnabled) return null;

  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Typography marginRight={6}>
          Would you like to restrict the permission to specific report types?
        </Typography>
        <RadioButtonGroupInput
          source={`permissions.${action}.isFilteringAttributes`}
          label=""
          choices={[{ id: 'yes', name: 'Yes' }, { id: 'no', name: 'No' }]}
          defaultValue={isFilteringAttributesDefaultValues}
          helperText={false}
          margin="none"
        />
      </Box>
      {isFilteringAttributes === 'yes' && (
        <SelectArrayInput
          source={`permissions.${action}.attributes.type`}
          label="Report types"
          choices={reportTypesDisplayChoices}
          size="small"
        />
      )}
    </Box>
  );
};

export default ReportInput;
